import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/logos/webpay.png")